import API from './api'
export interface PosterResult {
  data?: any
  code?: string
  error?: string
  config?: any
}

export const certificadosService = {
  pdf(form: any,id:number): Promise<PosterResult> {
    return API.postRequest(`/pdf/certificados/${id}`, form, {
      method: 'POST',
      responseType: 'blob',
    })
  },

  carta(form: any): Promise<any> {
    return API.postRequest('/pdf/carta', form, {
      method: 'POST',
      responseType: 'blob',
    }) as any
  },
}

export default certificadosService
